const actualDate = (offsetSec) => {
  const MILLISECONDS = 1000;
  const start = Date.now();
  const dateNow = new Date(
    start +
      new Date().getTimezoneOffset() * 60 * MILLISECONDS +
      offsetSec * MILLISECONDS
  );
  return dateNow;
};

const Clock = (offsetSec) => {
  const dateNow = actualDate(offsetSec);
  const today = (bate) => {
    return {
      day: bate.getDay(),
      numDay: bate.getDate(),
      month: bate.getMonth(),
      year: bate.getFullYear(),
    };
  };
  const hours = dateNow.getHours();
  const minutes = dateNow.getMinutes();
  const seconds = dateNow.getSeconds();
  const time = `${hours.length === 1 ? `0${hours}` : hours}:${
    minutes.length === 1 ? `0${minutes}` : minutes
  }:${seconds.length === 1 ? `0${seconds}` : seconds}`;
  return {
    today: today(dateNow),
    time,
    tick() {
      let [hh, mm, ss] = this.time.split(":").map((str) => +str);
      ss += 1;
      if (ss > 59) {
        ss = 0;
        mm += 1;
      }
      if (mm > 59) {
        mm = 0;
        hh += 1;
      }
      if (hh > 23) {
        hh = 0;
        this.today = today(actualDate(offsetSec));
      }
      const newTime = [hh, mm, ss]
        .map((num) => (`${num}`.length === 1 ? `0${num}` : `${num}`))
        .join(":");
      this.time = newTime;
      return { today: this.today, time: `${this.time}` };
    },
  };
};

export default Clock;
